import {cloneObject} from './functions';
import global from './global';

let Interface = {
    uid: 'defaultInterface',

    factory: function(obj_or_uid=null){
        if(obj_or_uid===null){
            let obj = cloneObject(this);
            obj.uid += Math.floor(99999*Math.random());
            return obj;
        }else if(typeof obj_or_uid == 'string'){
            let obj = global.controllers.get(obj_or_uid);
            if(!obj){
                console.warn('Object with uid ' + obj_or_uid + 
                        ' not found, using its interface');
                obj = cloneObject(this);
                obj.uid = obj_or_uid;
                global.controllers.set(obj.uid, obj);
            }
            return obj;
        }else{
            return obj_or_uid;
        }
    },

    addResponder: function(namespace, callback, defaultValue){  },
    removeResponder: function(name, remove){ },

};

export default Interface;